import React, { useState, useEffect } from 'react';
import { Heart } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useOutletContext } from 'react-router-dom';
import { toggleLike as apiToggleLike, getLikeStatus as apiGetLikeStatus } from '../api/client';

export default function LikeButton({ templateId, initialLikes }) {
  const { user, session } = useAuth();
  
  let setAuthOpen = null;
  try {
    const context = useOutletContext();
    setAuthOpen = context?.setAuthOpen;
  } catch (e) {}

  const [liked, setLiked] = useState(false);
  const [likesCount, setLikesCount] = useState(initialLikes || 0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!user || !session) {
      setLiked(false);
      return;
    }
    
    // Check status
    apiGetLikeStatus(templateId)
      .then(data => {
        if (data.liked !== undefined) setLiked(data.liked);
      })
      .catch(console.error);
  }, [templateId, user, session]);

  const handleToggleLike = async () => {
    if (!user) {
      if (setAuthOpen) setAuthOpen(true);
      else alert('Please log in to like this template.');
      return;
    }

    if (loading) return;
    setLoading(true);

    // Optimistic update
    const wasLiked = liked;
    setLiked(!wasLiked);
    setLikesCount(prev => wasLiked ? prev - 1 : prev + 1);

    try {
      const data = await apiToggleLike(templateId);
      // Sync with server response
      setLiked(data.liked);
      setLikesCount(data.count);
    } catch (err) {
      console.error(err);
      // Revert on error
      setLiked(wasLiked);
      setLikesCount(prev => wasLiked ? prev + 1 : prev - 1);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button 
      onClick={handleToggleLike}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        padding: '8px',
        borderRadius: '8px',
        color: liked ? 'var(--status-error)' : 'var(--text-secondary)',
        transition: 'all 0.2s ease',
        backgroundColor: liked ? 'rgba(255, 50, 50, 0.1)' : 'transparent'
      }}
      className={liked ? 'animate-scale-up' : ''}
    >
      <Heart size={20} fill={liked ? 'currentColor' : 'none'} />
      <span style={{ fontWeight: 500 }}>{likesCount}</span>
    </button>
  );
}
